import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Row, Select, Table, Tooltip } from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import commissionApi from "../../../../apis/Commission.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const InfluencerMonth = ({
  targetYear,
  setTargetYear,
  targetMonth,
  setTargetMonth,
  setNavType,
  influencerMonth,
  selectInfluencer,
  getQueryList,
  serviceInfo,
}) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const columns = [
    {
      title: "정산 월",
      dataIndex: "settlement_month",
      key: "settlement_month",
      width: 100,
      align: "center",
      render: (value) => {
        if (value) {
          return (
            <span
              style={{
                color: "#117ffa",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => {
                // setTargetYear("2023");
                setTargetMonth(moment(value).format("MM"));
                setNavType("case");
              }}
            >
              {moment(value).format("MM")}월
            </span>
          );
        }
      },
    },
    {
      title: "정산 완료일",
      dataIndex: "settlement_complete_date",
      key: "settlement_complete_date",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <p className={`${record?.commission_status ? "" : "blue"}`}>
              {moment(value).format("YYYY.MM.DD")}
            </p>
          );
        } else {
          return (
            <p>
              {moment(`${targetYear}.${targetMonth}.15`)
                .add(1, "month")
                .format("YYYY.MM.DD")}
            </p>
          );
        }
      },
    },
    {
      title: "정산 금액",
      dataIndex: "expected_payment_amount",
      key: "expected_payment_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            <p className={`${record?.commission_status ? "" : "blue"}`}>
              {value.toLocaleString()}
            </p>
          );
        } else return 0;
      },
    },
    {
      title: "판매 금액",
      dataIndex: "total_purchase_amount",
      key: "total_purchase_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return <p>{value.toLocaleString()}</p>;
        } else return 0;
      },
    },
    {
      title: "수익 금액",
      dataIndex: "profit_amount",
      key: "profit_amount",
      align: "center",
      render: (value, record) => {
        if (value) {
          return (
            // <p className={`${record?.commission_status ? "" : "red"}`}>
            <p>
              {/*<p className={`${record?.commission_status ? "" : "blue"}`}>*/}
              {/*-{value.toLocaleString()}*/}
              {value.toLocaleString()}
            </p>
          );
        } else return 0;
      },
    },
    {
      title: () => {
        return (
          <>
            카톡푸시 이용 금액
            {serviceInfo && (
              <Tooltip
                trigger={`click`}
                title={`발송 건수 X ${serviceInfo?.kakao_push_price}원`}
                overlayStyle={{ whiteSpace: "pre-wrap" }}
              >
                <img
                  src={`/assets/images/commission/notice.png`}
                  alt={`카톡푸시 이용 금액 안내`}
                  style={{
                    height: "1.1em",
                    width: "auto",
                    cursor: "pointer",
                    marginLeft: "3px",
                  }}
                />
              </Tooltip>
            )}
          </>
        );
      },
      width: 140,
      dataIndex: "kakao_push_fee",
      key: "kakao_push_fee",
      align: "center",
      render: (value) => {
        if (value) {
          return value.toLocaleString();
        } else {
          return "0";
        }
      },
    },
    // {
    //     title: '세금',
    //     dataIndex: 'withholding_tax',
    //     key: 'withholding_tax',
    //     align: "center",
    //     render: (value, record) => {
    //         if (value) {
    //             if (record.vat) {
    //                 return (
    //                     <p className={`${record?.commission_status ? "" : "red"}`}>
    //                         {value.toLocaleString()}
    //                     </p>
    //                 )
    //             } else {
    //                 return (
    //                     <p className={`${record?.commission_status ? "" : "red"}`}>
    //                         -{value.toLocaleString()}
    //                     </p>
    //                 )
    //             }
    //         } else return 0
    //     }
    // },
    {
      title: "정산 상태",
      dataIndex: "settlement_status",
      key: "settlement_status",
      align: "center",
      render: (value, record) => {
        let userType = user?.role === "super_admin";
        let target_confirm = record.target_confirm;
        // step 1) 당영은 데이터 보여주고, 인플루언는 데이터 가리기 - 정산 확정 후 value = 1;
        if (value === 0) {
          if (userType) {
            return (
              <Button
                className={`commission-button blue`}
                onClick={() => reportsFirst(record)}
              >
                {`정산요청`}
              </Button>
            );
          } else {
            return <p style={{ color: "#adb5bd" }}>정산예정</p>;
          }
        }
        // step 2) 인플루언서 정산 확인 -> 이전에는 당영에서 정산확인중(대기)
        else if (value === 1) {
          // 인플루언서 확인 대기 중
          if (!target_confirm) {
            return (
              <Button
                className={`commission-button ${userType ? "gray" : "blue"}`}
                // onClick={() => reportsSecond(record)}
              >
                {`${userType ? "정산확인 대기중" : "정산확인"}`}
              </Button>
            );
          }
        }
        // step 3) 당영 정산 확인 -> 이전에는 인플루언서에서 정산확인중(대기)
        else if (value === 2) {
          return (
            <Button
              className={`commission-button ${userType ? "blue" : "gray"}`}
              onClick={() => reportsThird(record)}
            >
              {`${userType ? "정산확정" : "정산확정 대기중"}`}
            </Button>
          );
        }
        // step 4) 정산 확정 완료
        else if (value === 3) {
          return (
            <Button className={`commission-button gray`} disabled={true}>
              {`확정완료`}
            </Button>
          );
        } else {
          return <p style={{ color: "#adb5bd" }}>정산예정</p>;
        }
      },
    },
    user?.role === "super_admin" && {
      title: "정산 취소",
      dataIndex: "settlement_status",
      key: "settlement_status",
      align: "center",
      width: 120,
      render: (value, record) => {
        let userType = user?.role === "super_admin";
        if (userType) {
          if (value === 1) {
            return (
              <Button
                className={`commission-button blue`}
                onClick={() => reportsCancel(record)}
                loading={isLoading}
              >
                {`정산취소`}
              </Button>
            );
          } else {
            if (value !== 0) {
              return (
                <Button className={`commission-button gray`} disabled={true}>
                  {`취소불가`}
                </Button>
              );
            } else return "-";
          }
        }
      },
    },
  ].filter((item) => item);

  /**
   * step 1) 정산요청버튼 -> 당영관리자
   * 정산 요청 버튼 클릭
   * @returns {Promise<void>}
   */
  const reportsFirst = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${moment(record.settlement_month).format(
            "YYYY년 M월",
          )} 내역의 정산요청을 진행하시겠습니까?`,
        )
      ) {
        let param = {
          settlement_type: 2,
          settlement_month: record.settlement_month,
          total_purchase_amount: record.total_purchase_amount,
          profit_amount: record.profit_amount,
          withholding_tax: 0,
          kakao_push_fee: record.kakao_push_fee,
          // dy_manage_fee : 당영 관리 수수료 (브랜드)
          // sales_fee : 매출 연동 수수료 (브랜드)
          expected_payment_amount: record.expected_payment_amount,
          created_by: user.id === 724 ? 1 : user.id,
          target_id: record.influencer_id,
        };
        const res = await commissionApi.postReportsFirst(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 정산이 요청되었습니다.`,
          );
          getQueryList(targetYear, targetMonth);
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  /**
   * step 2) 정산확인버튼 -> 인플루언서 (투게더에서 진행)
   * @param record
   * @returns {Promise<void>}
   */

  /**
   * step 3) 정산확정버튼 -> 당영
   * @param record
   * @returns {Promise<void>}
   */
  const reportsThird = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${moment(record.settlement_month).format(
            "YYYY년 M월",
          )} 내역의 정산확정을 진행하시겠습니까?`,
        )
      ) {
        let param = {
          id: record.id,
          settlement_type: record.settlement_type,
          settlement_month: record.settlement_month,
          influencer_id: record.influencer_id,
          created_by: user.id === 724 ? 1 : user.id,
        };
        const res = await commissionApi.postReportsThird(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 정산 확정되었습니다.`,
          );
          getQueryList(targetYear, targetMonth);
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  /**
   * 정산 취소
   * @param record
   * @returns {Promise<void>}
   */
  const reportsCancel = async (record) => {
    setIsLoading(true);
    try {
      if (
        window.confirm(
          `${"[" + selectInfluencer?.nickname + "]"} ${moment(
            record.settlement_month,
          ).format("YYYY년 M월")} 내역의 정산을 취소하시겠습니까?`,
        )
      ) {
        let param = {
          settlementId: record.id,
          userId: user.id === 724 ? 1 : user.id,
        };
        const res = await commissionApi.deleteSettlement(param);
        if (res.code === 200) {
          alert(
            `${moment(record.settlement_month).format(
              "YYYY년 M월",
            )} 내역이 취소되었습니다.`,
          );
          getQueryList(targetYear, targetMonth);
        } else {
          throw res.msg;
        }
      }
    } catch (e) {
      alert(e);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Row
        className="product-register-border-box"
        justify={"space-between"}
        wrap={false}
        style={{ marginTop: 20, borderBottom: 0 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span className="product-register-box-title">정산내역 및 목록</span>
          <p style={{ margin: 0, fontSize: "0.8rem", color: "#117ffa" }}>
            구매확정(배송완료일로부터 7일 후)을 기준으로 정산기준일 +1영업일째
            되는 날 정산 된 내역만 표기되어 매출액과 상이할 수 있습니다.
          </p>
        </div>
      </Row>
      <div
        className="product-register-border-box"
        wrap={false}
        style={{ padding: "20px 25px 40px", height: "fit-content" }}
      >
        <div className={`commission-year-select`}>
          <p>정산년도</p>
          <Select
            value={targetYear}
            onChange={(value) => {
              setTargetYear(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 년도"}
          >
            {["2022", "2023", "2024"]?.map((item) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
          <Select
            value={targetMonth}
            onChange={(value) => {
              setTargetMonth(value);
            }}
            style={{ width: 150, textAlign: "left" }}
            placeholder={"정산 월"}
          >
            {Array.from({ length: 12 })?.map((item, idx) => (
              <Option
                key={`year ${idx + 1}`}
                value={idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              >
                {idx + 1 >= 10 ? idx + 1 : `0${idx + 1}`}
              </Option>
            ))}
          </Select>
        </div>
        <Table
          className={`commission-table`}
          // rowSelection={rowSelection}
          columns={columns}
          // dataSource={selectInfluencer.id?.length !== 0 ? commissionList : []}
          dataSource={influencerMonth}
          loading={isLoading}
          bordered
          size="small"
          rowKey="month"
          rowClassName="coupon-table-row"
          // scroll={{x: 'calc(700px + 50%)'}}
          // onChange={tableOnChange}
          pagination={false}
        />
      </div>
    </>
  );
};
export default InfluencerMonth;
